import { Injectable } from "@angular/core";
import { RouteToFeatureFlagType } from "src/app/models/featureFlag/RouteToFeatureFlagType.model";
import { environment } from "src/environments/environment";
import { LoggerService } from "../logger/logger.service";
import { UserService } from "../user/user.service";
import featureFlagsConfigJson from "./feature-flags.json";

interface FeatureFlagEnvConfig {
    enabled_orgs: string;
    disabled_orgs?: string;
}

type FeatureFlagConfig = { [envName: string]: FeatureFlagEnvConfig };

type FeatureFlagsConfig = { [featureFlagName: string]: FeatureFlagConfig };

@Injectable({
    providedIn: "root",
})
export class FeatureFlagsService {
    private _environmentName: string;
    private _featureFlagsConfig: FeatureFlagsConfig = featureFlagsConfigJson;

    constructor(
        private _userService: UserService,
        private _logger: LoggerService,
    ) {
        this._environmentName = environment.name;
    }

    public isFeatureEnabled(key: string): boolean {
        const featureFlagConfig: FeatureFlagConfig = this._featureFlagsConfig[key];
        if (!featureFlagConfig) {
            this._logger.error("Feature flag doesn't exist: " + key);
            return false;
        }

        const featureFlagEnvConfig: FeatureFlagEnvConfig = featureFlagConfig[this._environmentName];
        if (!featureFlagEnvConfig) {
            return false;
        }

        if (featureFlagEnvConfig.disabled_orgs === "*") {
            return false;
        }

        if (featureFlagEnvConfig.disabled_orgs && this._isOrgIncludedInOrgsStr(featureFlagEnvConfig.disabled_orgs)) {
            return false;
        }

        if (featureFlagEnvConfig.enabled_orgs === "*") {
            return true;
        }

        return this._isOrgIncludedInOrgsStr(featureFlagEnvConfig.enabled_orgs);
    }

    public canActivateRoute(routeEndpoint: string): boolean {
        if (routeEndpoint in RouteToFeatureFlagType) {
            const featureFlagType = RouteToFeatureFlagType[routeEndpoint];
            return this.isFeatureEnabled(featureFlagType);
        }

        return true;
    }

    private _isOrgIncludedInOrgsStr(orgs_str: string) {
        return orgs_str
            .split(",")
            .map((org) => org.trim())
            .includes(this._userService.zenityAccountId);
    }
}
